import { isPtacSystemPreference } from '@alpinehomeair/common';
import { isEpOnlySystemPreference } from './project';

// Pathways that never ask about ducted existing equipment: switching INTO
// one removes the non-panel equipment entered on a ducted/hybrid project.
export function isEquipmentClearingSystemPreference(value: unknown): boolean {
  return isEpOnlySystemPreference(value) || isPtacSystemPreference(value);
}

export type EquipmentClearingSwitchDialog = {
  title: string;
  message: string;
  swapButtonColors: boolean;
};

export function equipmentClearingSwitchDialog(
  nextValue: string
): EquipmentClearingSwitchDialog {
  if (isPtacSystemPreference(nextValue)) {
    return {
      title: 'Switch to Hotel Style (PTAC)?',
      message:
        "Ducted existing equipment doesn't apply to a PTAC project. " +
        "Switching will remove the existing equipment you've entered. " +
        'Your electrical panel will be kept.',
      swapButtonColors: true
    };
  }
  return {
    title: 'Switch to Ductless Mini Split?',
    message:
      "Ducted existing equipment doesn't apply to a ductless project. " +
      "Switching will remove the existing equipment you've entered. " +
      'Your electrical panel will be kept.',
    swapButtonColors: false
  };
}
